<style lang="less" scoped>
@import url('../../../style/common/variable.less');
@media screen and (max-width: @max-screen)
{
  .cardImgkyxm{width: 100%;height: 100%;}
  .main{width: 100%;}
  ul {width: 100%;margin: 0;padding: 0;display: flex;flex-wrap: wrap;height: 100%;
    li{padding: 0;display: flex;flex-direction: column;align-items: center;width: 100%;margin: auto;
      .xq{font-size: 10px;}
      .time{font-size:12px;}
      .box1{width: 100%;height: 100%;
        .pic{width: 100%;height: 100%;margin-top: 5%;
          img {width: 100%;transition: transform .5s;}
        }
        .box2{width: 100%;height: 100%;
          .boxDiv{display: flex;justify-content: space-between; margin-bottom: 5%;}
          .text{width: 100%;margin: 3% 0;overflow: scroll;}
        }
      }
    }
  }
}
@media screen and (min-width: @max-screen)
{
  .cardImgkyxm{width: 100%;position: relative;height: 350px;}
  ul {width: 1200px;height: 294px;
    li{margin-left: -30px;margin-top: -15px;float: left;
      .time{position: absolute;top: 80px;left: 10px;}
      .xq {position: absolute;top: 80px;left: 200px;font-size: 5px;color:rgb(0, 183, 255);cursor: pointer;}
      .box1{width: 265px;position: relative;height: 320px;
        .pic{position: absolute;top: 16px;left: 2px;width: 260px;height: 160px;
          img {width: 260px;height: 160px;transition: transform .5s;}
        }
        .box2{position: absolute;top: 214px;width: 246px;height: 82px;
          .text{position: absolute;top: 5px;width: 220px;height: 40px;overflow: hidden;}
        }
      }
    }
  }
}
.cardImgkyxm {text-align: left;}
ul {list-style: none;display: flex;
li {flex: 1;cursor: pointer;
.box1 {z-index: 9;
.pic {overflow: hidden;
img {transition: transform .5s;}
img:hover {transform: scale(1.2,1.2)}}
.box2 {z-index: 99;
.name {position: absolute;top: 15px;left: 18px;font-size: 18px;font-weight: 800;font-family: STSong;}
.name:hover {color: rgb(230, 19, 19);}
.description {position: absolute;top: 12px;left: 10px;font-size: 13px;}
.text {font-weight:bold;left: 10px;line-height:20px;font-size: 13px;-webkit-line-clamp: 2;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;}}}
.text{line-height: 16px; overflow:hidden;}
.text::after{content: ' ... ';}
.time {font-size: 13px;}
.xq {color:rgb(0, 183, 255);cursor: pointer;}
.box1:hover {box-shadow: 0 4px 6px rgba(13, 230, 230, 0.12), 0 0 8px rgba(0, 0, 0, .04)}}}
.name{font-size: 15px;display: block;font-weight: bold;width: 265px;text-align: center;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
.more{cursor: pointer;color: #2c3e50;font-weight:600;float:right;margin-right:12px;margin-top: -50px;}
</style>

<!--李旭 2021.6.7
    该卡片组件使用场景：展示某张图片和名称以及相关信息。鼠标点击 更多 或者 图片及名称、信息，返回 对应的对象 给父组件 -->
<template>
  <div class="cardImgkyxm">
    <div class="main">
      <ul class="text">
        <li v-for="(item, index) in cardImgkyxmList" :key="index" @click="clickImgName(item)">
          <div class="name"> {{ item.title }} </div>
          <div class="box1" >
            <div class="pic">
              <img :src="item.pic" />
            </div>
            <div class="box2">
              <span class="text"> {{ item.text }} </span>
              <div class="boxDiv">
                <span class="time">更新时间:{{ item.time * 1000 | formatDate() }}</span>
                <span class="xq">详情 >></span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  mixins: [filters],
  props: ['cardImgkyxmList'],
  data()
  {
    return {
    }
  },
  updated()
  {
    var oList = document.querySelectorAll('.text')
    var alltableArray = Array.prototype.slice.call(oList)
    alltableArray.forEach(function(item)
    {
      var oHeight = item.height
      if ((oHeight / 15) > 2)
        item.className = 'text'
    })
  },
  methods: {
    // 点击“更多”按钮，将该 button对象 传递给父组件
    getmore(button)
    {
      this.$emit('getmore', button)
    },
    // 点击公司图片或者名称，将 整个公司对象 传递给父组件
    clickImgName(item)
    {
      this.$emit('clickImgName', item)
    }
  }
}
</script>
<!--  父组件数据格式
list: [
        {
          type: '矿业项目',
          button: {
            value: '更多',
            path: ''
          },
          text: [
            {
              pic: '../../../static/img/企业展示.png',
              company: {
                name: '武汉智博科技创享公司',
                path: ''
              },
              description: '经营范围',
              text: '你好，欢迎来到武汉智博科技创享',
              time:'2021-6-7'
            },
            {
              pic: '../../../static/img/企业展示.png',
              company: {
                name: '中国地质大学',
                path: ''
              },
              description: '经营范围',
              text: '你好，欢迎来到中国地质大学',
              time:'2021-6-7'
            },
          ]
        }
      ]
-->



// WEBPACK FOOTER //
// src/plugins/app/assembly/CardImgkyxm.vue